import axios from 'axios'

// 这里配置统一的基础地址，后续你只需要改 baseURL 即可
// 开发环境推荐留空，配合 vue.config.js 的 devServer.proxy 解决跨域
const http = axios.create({
  baseURL: '',
  timeout: 10000
})

// 请求拦截器：可以在这里统一加 token、语言等
http.interceptors.request.use(
  config => {
    // 为所有请求统一注入登录 token
    const token = localStorage.getItem('token')
    // 仅当 token 是可见 ASCII 时设置到 Header，防止中文等字符导致浏览器报错
    const isAsciiToken = typeof token === 'string' && !/[^\u0020-\u007E]/.test(token)
    if (isAsciiToken) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器：统一处理 Result<T> 包装
http.interceptors.response.use(
  response => {
    const res = response.data
    // 如果后端统一使用 { code, message, data } 结构
    if (typeof res === 'object' && res !== null && 'code' in res) {
      // 兼容部分接口使用 code=1 表示成功的情况
      if (res.code !== 0 && res.code !== 1) {
        // 这里不直接弹 toast，交给调用方决定
        const err = new Error(res.message || '请求失败')
        err.code = res.code
        err.raw = res
        throw err
      }
      return res.data
    }
    // 非标准结构，直接返回原始数据
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export default http
